module.exports = __webpack_public_path__ + "8311d192d7a30aa05fde473cee6a7534.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/bg_01.png
// module id = 939
// module chunks = 3